import {Component, Input, OnInit} from '@angular/core';
import {LokijsService} from '../../services/database/lokijs.service';
import {DocumentModel} from '../../models/document.model';
import {LocationModel} from '../../models/location.model';

@Component({
    selector: 'location-select',
    templateUrl: './location-select.component.html',
    styleUrls: ['./location-select.component.scss'],
})
export class LocationSelectComponent implements OnInit {

    @Input() document: DocumentModel;
    depots: LocationModel[];

    constructor(private loki: LokijsService) {
    }

    ngOnInit() {
        this.depots = this.loki.getCollection('depot').chain().simplesort('descr').data();
    }
}
